import { render } from "./DebatersArticleSelectable.vue?vue&type=template&id=7a3e879e&scoped=true"
import script from "./DebatersArticleSelectable.vue?vue&type=script&lang=js"
export * from "./DebatersArticleSelectable.vue?vue&type=script&lang=js"

import "./DebatersArticleSelectable.vue?vue&type=style&index=0&id=7a3e879e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3e879e"]])

export default __exports__